import { Component, OnInit } from '@angular/core';
import { DashboardHeaderComponent } from '../dashboard-header/dashboard-header.component';
import { UserLoginFooterComponent } from '../user-login-footer/user-login-footer.component';
import { RouterOutlet } from '@angular/router';
import { DashboardFooterComponent } from '../dashboard-footer/dashboard-footer.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    DashboardHeaderComponent,
    UserLoginFooterComponent,
    RouterOutlet,
    DashboardFooterComponent,
  ],
  templateUrl: './layout.component.html',
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
      }
      .main-content {
        flex: 1;
        padding-top: 30px;
      }
    `,
  ],
})
export class LayoutComponent implements OnInit {
  isB2BMode = false;

  ngOnInit() {
    this.isB2BMode = sessionStorage.getItem('isB2BMode') === 'true';
  }
}
